module.exports = __webpack_public_path__ + "static/img/before7.5f2fb0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/orgextension/before7.jpg
// module id = tpXJ
// module chunks = 9